import {
  BlockDataType,
  EDITOR_MODE,
  ViewerStateWithSyncer,
  useEditorStateSelector
} from "@pathwright/blocks-engine"
import { useBlocksLinks } from "../blocksLinks/functions"
import { LazyQuillEditor } from "@pathwright/ui/src/components/quill/LazyQuillEditor"
import View from "@pathwright/ui/src/components/ui/View"
import { usePreload } from "@pathwright/ui/src/components/utils/preload"
import ErrorOverlay from "../ui/ErrorOverlay"
import { DefaultLoadingWithTimeout } from "../utils/LoadingWithTimeout"
import { ContentViewer } from "../viewer/ContentViewer"
import ContentEditorBlocks from "./ContentEditorBlocks"
import ContentEditorControls from "./ContentEditorControls"

export const ContentEditor = () => {
  const mode = useEditorStateSelector((state) => state.mode)
  const error = useEditorStateSelector((state) => state.error)
  const contentLoading = useEditorStateSelector((state) => state.contentLoading)
  const handleBlockChange = useEditorStateSelector(
    (state) => state.handleBlockChange
  )

  useBlocksLinks("EDIT")

  // Optimistic user scoped update for Editor Preview mode
  const handleViewerBlockChange = (
    data: BlockDataType,
    id: string,
    trackProgress: boolean
  ) => {
    handleBlockChange(data, id)
  }

  // HACK: showing loader until QuillEditor is loaded for a more
  // seemless transition from loading to displaying content
  const [preloading] = usePreload({
    Component: LazyQuillEditor,
    preload: true
  })

  if ((preloading && process.env.NODE_ENV !== "test") || contentLoading)
    return <DefaultLoadingWithTimeout />

  return (
    <View.Primary
      id="blocks-content-editor"
      style={{
        minHeight: error ? "450px" : null,
        position: "relative",
        boxShadow: mode === "edit" ? "0 0 3px 1px rgba(0,0,0,0.1)" : "none"
      }}
    >
      {error && (
        <ErrorOverlay
          error={error?.message || ""}
          explanation={
            typeof error === "string"
              ? error
              : error?.message?.includes("publish")
              ? "Please add blocks and try publishing again."
              : ""
          }
        />
      )}
      <ContentEditorControls />
      {mode === EDITOR_MODE.VIEW ? (
        // Editor preview mode
        <ViewerStateWithSyncer
          draft={true} // This allows student data to be saved on draft blocks
        >
          <ContentViewer />
        </ViewerStateWithSyncer>
      ) : (
        <ContentEditorBlocks key={`blocks-${mode}`} />
      )}
    </View.Primary>
  )
}
